<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <div class="form-div">
    <form class="user-form">
      <p class="heading">What year were you born?</p>
      <mat-form-field 
        appearance="fill" 
        class="full-width rounded-input black-caret"
        [class.valid-input]="yearControl.valid && yearControl.value && !yearControl.disabled"
        [class.invalid-input]="yearControl.invalid && yearControl.touched && availableYears.length === 0 && !yearControl.disabled"
        [class.has-suggestions]="availableYears.length > 0 && !yearControl.disabled"
      >
        <input
          type="text"
          matInput
          [formControl]="yearControl"
          [matAutocomplete]="auto"
          required
        />
        <span matSuffix class="dropdown-arrow">
          <i class="fa-solid fa-caret-down"></i>
        </span>
        <mat-autocomplete #auto="matAutocomplete" class="separated-dropdown-options">
          @for (year of filteredYears | async; track $index) {
            <mat-option [value]="year">
              {{ year }}
            </mat-option>
          }
        </mat-autocomplete>

        @if (yearControl.hasError('required') && (
          yearControl.touched || yearControl.dirty)
        ) {
          <mat-error class="input-error">
            Please select a year
          </mat-error>
        }

        @if (yearControl.hasError('invalidYear') && yearControl.touched) {
          <mat-error class="input-error">
            Invalid year
          </mat-error>
        }
      </mat-form-field>
      
      <mat-checkbox [formControl]="preferNotToSayControl" class="checkbox-item">
        Prefer not to say
      </mat-checkbox>

      <app-biq-button (buttonEmitter)="onClickContinue()"></app-biq-button>
    </form>
  </div>
</div>